import {Injectable, signal} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {BehaviorSubject} from 'rxjs';
import {KtPaymentFilterForm, KtPaymentFilterModel} from '../models/kt-filter.model';

@Injectable({providedIn: 'root'})
export class KtPaymentsFilterService {
  public readonly filtersValue = signal<KtPaymentFilterModel>(this.buildDefaultFilters());
  public readonly toggleModal = signal<boolean>(false);

  private readonly filters$ = new BehaviorSubject<KtPaymentFilterModel>(this.filtersValue());

  public get form(): KtPaymentFilterForm {
    return new FormGroup({
      TripReference: new FormControl<string | null>(null),
      TravelerName: new FormControl<string | null>(null),
      ProductTypeName: new FormControl<string | null>(null),
      PaymentDateFrom: new FormControl<Date | null>(null),
      PaymentDateTo: new FormControl<Date | null>(null),
    });
  }

  public getFilters() {
    return this.filters$.asObservable();
  }

  public setFilters(value: KtPaymentFilterModel): void {
    this.filtersValue.set(value);
    this.filters$.next(value);
  }

  private buildDefaultFilters(): KtPaymentFilterModel {
    return {
      TripReference: null,
      TravelerName: null,
      ProductTypeName: null,
      PaymentDateFrom: null,
      PaymentDateTo: null,
      ReloadGrid: false,
    };
  }
}
